import Tippy, { useSingleton } from "@tippyjs/react";
import { useAtomValue } from "jotai";
import { boardInfoAtom, buttonDisabledAtom, headerActiveButtonAtom } from "@/interface/AppStore";
import { BoardNameField } from "@/interface/HeaderBar/LeftBar/BoardNameField";
import { ContextMenu } from "@/interface/HeaderBar/LeftBar/ContextMenu";
import { ExportButton } from "@/interface/HeaderBar/LeftBar/ExportButton";
import { FavouriteButton } from "@/interface/HeaderBar/LeftBar/FavouriteButton";
import { UpgradeTariffButton } from "@/interface/HeaderBar/LeftBar/UpgradeTariffButton";
import styles from "./LeftBar.module.css";
import { LogoLink } from "./LogoLink";

type LeftBarProps = {
    className?: string;
};

export const LeftBar = ({ className }: LeftBarProps) => {
    const [source, target] = useSingleton();
    const {
        boardName,
        canUseFavourite,
        isFavourite,
        isProfessional,
        isTeamOwner,
        boardMode,
        teamId,
    } = useAtomValue(boardInfoAtom);
    const openSidebarName = useAtomValue(headerActiveButtonAtom);
    const buttonDisabled = useAtomValue(buttonDisabledAtom);
    const showTariff = !isProfessional && isTeamOwner === true;
    const showExport = !(boardMode === "view" || boardMode === "view_mini");

    return (
        <div className={className}>
            <Tippy singleton={source} />
            <LogoLink singletoneTarget={target} />
            <div className={styles.actions}>
                <BoardNameField singletoneTarget={target} boardName={boardName} />

                {canUseFavourite && (
                    <FavouriteButton isFavourite={isFavourite} singletoneTarget={target} />
                )}

                {showExport && (
                    <ExportButton
                        singletoneTarget={target}
                        isActive={openSidebarName === "export"}
                        isDisabled={buttonDisabled.export ?? false}
                    />
                )}

                <ContextMenu singletoneTarget={target} isActive={openSidebarName === "settings"} />
            </div>

            {showTariff && (
                <UpgradeTariffButton className={styles.upgradeTariffBtn} teamId={teamId} />
            )}
        </div>
    );
};
